const config = {
  apiPath: process.env.NEXT_PUBLIC_API_PATH,
  graphqlSubscriptionsWsHost: process.env.NEXT_PUBLIC_GRAPHQL_SUBSCRIPTIONS_WS_HOST,
}

export default config
